import produce from 'immer';
import {
  SET_STORE_LOGOS_START,
  SET_STORE_LOGOS_SUCCESS,
  SET_STORE_LOGOS_FAILED,
  GET_STORE_LOGOS_SUCCESS,
  GET_STORE_LOGOS_FAILED,
  GET_CONFIGS_LOGOS_START,
  GET_CONFIGS_LOGOS_SUCCESS,
  GET_CONFIGS_LOGOS_FAILED,
  UPLOAD_STORE_LOGOS_START,
  UPLOAD_STORE_LOGOS_SUCCESS,
  UPLOAD_STORE_LOGOS_FAILED,
  UPLOAD_STORE_LOGOS_TYPE_FAILED,
  SET_CONFIG_LOGOS_START,
  SET_CONFIG_LOGOS_SUCCESS,
  SET_CONFIG_LOGOS_FAILED,
  UPDATE_ALL_LOGOS_START,
  UPDATE_ALL_LOGOS_SUCCESS,
  UPDATE_ALL_LOGOS_FAILED
} from 'redux/actions/general';


const initialState = {
  logos: {
    store: {
      title: 'store logo',
      name: 'store',
      customPath: ''
    },
    email: {
      title: 'email logo',
      name: 'email',
      customPath: ''
    },
    favicon: {
      title: 'favicon',
      name: 'favicon',
      customPath: ''
    },
    invoice: {
      title: 'invoice logo',
      name: 'invoice',
      customPath: 'sales/store/logo'
    },
    gift: {
      title: 'gift card logo',
      name: 'gift',
      customPath: 'dermpro/giftcard'
    },
    loading: true,
  },
  loadigUpdateAllLogos: false
};


const formReducer = produce((state: IGeneralState = initialState, action) => {
  switch (action.type) {
    case GET_STORE_LOGOS_SUCCESS: {
      const {data} = action;
      state.logos.loading = true;
      state.logos.storeConfiguration = data;
      state.logos.store = {...state.logos.store, url: data.header_logo_src.length > 0 ? data.header_logo_src[0].url : ''};
      state.logos.email = {...state.logos.email, url: data.email_logo.length > 0 ? data.email_logo[0].url : ''};
      state.logos.favicon = {...state.logos.favicon, url: data.head_shortcut_icon.length > 0 ? data.head_shortcut_icon[0].url : ''};
      state.logos.loading = false;
      break;
    }
    case GET_STORE_LOGOS_FAILED: {
      state.logos.loading = false;
      break;
    }
    case GET_CONFIGS_LOGOS_START: {
      state.logos.loading = true;
      break;
    }
    case GET_CONFIGS_LOGOS_SUCCESS: {
      const {data, apiUrl} = action;
      const giftCardConfig = data.config.find((item) => item.path === 'mpgiftcard/template/logo');
      const invoiceConfig = data.config.find((item) => item.path === 'sales/identity/logo');

      state.logos.gift = {...state.logos.gift, ...giftCardConfig},
      state.logos.gift.url = giftCardConfig.value ? `${apiUrl}/media/dermpro/giftcard/${giftCardConfig.value}` : '';
      state.logos.invoice = {...state.logos.invoice, ...invoiceConfig};
      state.logos.invoice.url = invoiceConfig ? `${apiUrl}/media/sales/store/logo/${invoiceConfig.value}` : '';
      state.logos.configData = data;
      state.logos.loading = false;
      break;
    }
    case GET_CONFIGS_LOGOS_FAILED: {
      state.logos.loading = false;
      break;
    }
    case UPLOAD_STORE_LOGOS_START: {
      state.logos.loading = true;
      break;
    }
    case UPLOAD_STORE_LOGOS_SUCCESS: {
      const {data, key} = action;

      state.logos[key] = {...state.logos[key], uploadedLogoData: {...data}};
      state.logos[key].url = data.url;

      if (key === 'store') {
        state.logos.storeConfiguration.header_logo_src[0] = {...data};
      } else if (key === 'email') {
        state.logos.storeConfiguration.email_logo[0] = {...data};
      } else if (key === 'favicon') {
        state.logos.storeConfiguration.head_shortcut_icon[0] = {...data};
      } else if (key === 'gift') {
        state.logos.configData.config[0].value = data.name;
      } else if (key === 'invoice') {
        state.logos.configData.config[1].value = data.name;
      } else if (key === 'invoice_html') {
        state.logos.configData.config[2].value = data.name;
      }

      state.logos.loading = false;
      break;
    }
    case UPLOAD_STORE_LOGOS_FAILED: {
      state.logos.loading = false;
      break;
    }
    case UPLOAD_STORE_LOGOS_TYPE_FAILED: {
      state.logos.loading = false;
      break;
    }
    case SET_STORE_LOGOS_START: {
      state.logos.loading = true;
      break;
    }
    case SET_STORE_LOGOS_SUCCESS: {
      const { data } = action;
      state.logos.loading = true;
      state.logos.storeConfiguration = data;
      state.logos.loading = false;
      break;
    }
    case SET_STORE_LOGOS_FAILED: {
      state.logos.loading = false;
      break;
    }
    case SET_CONFIG_LOGOS_START: {
      state.logos.loading = true;
      break;
    }
    case SET_CONFIG_LOGOS_SUCCESS: {
      const {data} = action;

      state.logos.loading = true;
      state.logos.responseConfigData = data;
      state.logos.loading = false;
      break;
    }
    case SET_CONFIG_LOGOS_FAILED: {
      state.logos.loading = false;
      break;
    }
    case UPDATE_ALL_LOGOS_START: {
      state.loadigUpdateAllLogos = true;
      break;
    }
    case UPDATE_ALL_LOGOS_SUCCESS: {
      state.loadigUpdateAllLogos = false;
      break;
    }
    case UPDATE_ALL_LOGOS_FAILED: {
      state.loadigUpdateAllLogos = false;
      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
